var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-content-geral',{attrs:{"topSpace":_vm.busTopSpace}}),_c('how-it-works'),_c('depoiments-all'),_c('press')],1)}
var staticRenderFns = []

export { render, staticRenderFns }